/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import { BaseApiClient, RequestContext, ApiConfigManager, HttpRequestState } from '@sg/api/base-api-lib';
import { IdentityServerApiConfig } from '../api-config';

import { IdentityServerApi } from '../models';

@Injectable()
export class LogsApiClient extends BaseApiClient<IdentityServerApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.identityServerApiConfig);
  }

  logsControllerPostApiIdentityLogsSearch(
    params?: {
      body?: IdentityServerApi.SearchUserLoginsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'time' | 'uuid' | 'type' | 'subType';
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<IdentityServerApi.UserLoginEventDtoSearchUserLoginsOrderPagingResultDto>;
  logsControllerPostApiIdentityLogsSearch(
    params?: {
      body?: IdentityServerApi.SearchUserLoginsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'time' | 'uuid' | 'type' | 'subType';
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<IdentityServerApi.UserLoginEventDtoSearchUserLoginsOrderPagingResultDto>>;
  logsControllerPostApiIdentityLogsSearch(
    params?: {
      body?: IdentityServerApi.SearchUserLoginsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'time' | 'uuid' | 'type' | 'subType';
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<IdentityServerApi.UserLoginEventDtoSearchUserLoginsOrderPagingResultDto>;
  logsControllerPostApiIdentityLogsSearch(
    params?: {
      body?: IdentityServerApi.SearchUserLoginsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'time' | 'uuid' | 'type' | 'subType';
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<IdentityServerApi.UserLoginEventDtoSearchUserLoginsOrderPagingResultDto>>;
  logsControllerPostApiIdentityLogsSearch(
    params?: {
      body?: IdentityServerApi.SearchUserLoginsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'time' | 'uuid' | 'type' | 'subType';
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<IdentityServerApi.UserLoginEventDtoSearchUserLoginsOrderPagingResultDto>>;
  logsControllerPostApiIdentityLogsSearch(
    params?: {
      body?: IdentityServerApi.SearchUserLoginsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'time' | 'uuid' | 'type' | 'subType';
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<IdentityServerApi.UserLoginEventDtoSearchUserLoginsOrderPagingResultDto>>;
  logsControllerPostApiIdentityLogsSearch(
    params?: {
      body?: IdentityServerApi.SearchUserLoginsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'time' | 'uuid' | 'type' | 'subType';
    },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    const consumes = ['application/json'];

    if (params) {
      requestContext.queryParams = this.createQueryParams(
        ['', 'pageSize', params.pageSize],
        ['', 'pageNumber', params.pageNumber],
        ['', 'sortDirection', params.sortDirection],
        ['', 'orderBy', params.orderBy]
      );
    }

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<IdentityServerApi.UserLoginEventDtoSearchUserLoginsOrderPagingResultDto>(
      `${this.basePath}/gateway/admin/logs/search`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
